import store from 'nette-base-module/js/store'

export default {
  data () {
    return {
      loading: false,
      percentCompleted: 0,
      uploadError: false
    }
  },
  methods: {
    error (error) {
      this.uploadError = error
      this.loading = false
    },
    progress (progress, percentCompleted) {
      this.loading = true
      this.percentCompleted = percentCompleted
      this.uploadError = false

      if (percentCompleted === 100) {
        setTimeout(() => {
          this.percentCompleted = 0
        }, 1000)
      }
    }
  },
  computed: {
    mediaObjectsComputed: {
      get() {
        return this.$presenter.mediaObjects
      },
      set (val) {
        store.dispatch('nette/updateDataKey', {
          data: val,
          key: 'mediaObjects'
        })
      }
    }
  }
}
